<template>

	<v-card class="mt-4">

		<v-simple-table dense v-if="fuente.listado" :loading="fuente.listando">
			<template v-slot:default>
				<thead>
					<tr>
						<th></th>
						<th>Motivo</th>
						<th>Fecha</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="m in fuente.listado" :key="m.identificador">
						<td>
							<h3 v-if="m.tipo === 'entrada'" class="green--text">+{{ número(m.cantidad) }}</h3>
							<h3 v-if="m.tipo === 'salida'" class="red--text">-{{ número(m.cantidad) }}</h3>
						</td>
						<td>
							<span v-if="m.origen === 'venta'" class="grey--text font-italic">Venta</span>
							<span v-else-if="m.origen === 'anulación_de_venta'" class="grey--text font-italic">
								Anulación de venta
							</span>
							<span v-else-if="m.origen === 'compra'" class="grey--text font-italic">Compra</span>
							<span v-else-if="m.origen === 'anulación_de_compra'" class="grey--text font-italic">
								Anulación de compra
							</span>
							<span v-else-if="m.origen === 'creación_de_producto'" class="grey--text font-italic">
								Existencia inicial tras creación de producto
							</span>
							<span v-else>{{ m.motivo }}</span>
						</td>
						<td>{{ new Date(m.creación.fecha.seconds * 1000).toLocaleString('es') }}</td>
					</tr>
				</tbody>
			</template>
		</v-simple-table>

	</v-card>

</template>

<script>
import { movimientoDeInventarioDeProducto } from '@/../../cliente_comun/fuentes'
import { número, moneda } from '@/../../cliente_comun/utilidades'

export default {
	name: 'movimiento-de-inventario-de-producto',
  data: () => ({
		fuente: movimientoDeInventarioDeProducto,
	}),
	watch: {
		'identificador': (v) => {
			if (v) {
				this.fuente.listar(v)
			} else {
				this.fuente.listado = []
				if (this.fuente.desconectar) {
					this.fuente.desconectar()
				}
			}
		}
	},
	props: ['identificador'],
	created: function() {
		if (this.identificador) {
			this.fuente.listar(this.identificador)
		}
	},
	methods: {
		número,
		moneda,
	}
}
</script>